'use client';

import { type JSX } from 'react';

import { Label, TextAreaInput, TextAreaInputProps } from '@videoblocks/design-system';

export type TextAreaInputFieldProps = TextAreaInputProps;

export const TextAreaInputField = ({ ...rest }: TextAreaInputFieldProps): JSX.Element => {
    return (
        <div className="flex flex-col gap-2 w-full">
            <Label htmlFor="text-prompt" className="text-left" fontSize="sm">
                Prompt
            </Label>
            <TextAreaInput
                showCount
                textAreaClassName="min-w-0 field-sizing-fixed"
                resize="none"
                id="text-prompt"
                name="text-prompt"
                {...rest}
            />
        </div>
    );
};
